import { SVG } from '../svg';
import { IconProps } from '../types';

export function ChevronRightIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="m9 18 6-6-6-6" />
    </SVG>
  );
}
